import React from 'react';
import { makeStyles } from '@material-ui/styles';
import { Typography, Grid, CardActionArea, CardMedia, Card, Fab, useMediaQuery } from '@material-ui/core';
import useMobile from 'utils/useMobile';
import { withRouter } from 'react-router-dom';
import cdn from 'utils/cdn';
import classNames from 'class-names';

const useStyles = makeStyles(() => ({
  root: {
    paddingTop: 48,
    paddingBottom: 48
  },
  grid: {
    width: '100%',
    margin: 0
  },
  absContainer: {
    position: 'absolute',
    display: 'flex',
    height: '100%',
    overflow: 'hidden',
    width: '100%',
    alignItems: 'center',
    justifyContent: 'center'
  },
  gridItem: {
    position: 'relative',
    marginTop: 16,
    marginBottom: 16
  },
  cardImage: {
    height: 250
  },
  titleText: {
    zIndex: 10,
    color: '#fff'
  },
  titleContainer: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  card: {
    position: 'relative' // to center inner button
  },
  fab: {
    zIndex: 10,
    paddingLeft: 32,
    paddingRight: 32
  },
  padRight: {
    paddingRight: 16
  },
  padLeft: {
    paddingLeft: 16
  },
  sectionTitle: {
    marginLeft: 32
  }
}));

const LinkGrid = ({ title, data, history }) => {
  const classes = useStyles({});
  const isMobile = useMobile();
  const titleSize = isMobile ? 'h4' : 'h3';
  const isFullWidth = useMediaQuery(({ breakpoints }) => breakpoints.up('md'));

  const toUrl = id => cdn.url(id, { width: 1000, crop: 'fit', background: 'black', opacity: 70 });

  return (
    <div className={classes.root}>
      <Typography
        className={classes.sectionTitle}
        variant={titleSize}
        gutterBottom
        align={isMobile ? 'center' : 'left'}
      >
        {title}
      </Typography>
      <Grid className={classes.grid} container alignContent="space-between">
        {data.map(({ title, cdnId, route }, i) => (
          <Grid
            key={i}
            className={classNames(classes.gridItem, {
              [classes.padRight]: isFullWidth && i % 2 === 0,
              [classes.padLeft]: isFullWidth && i % 2 === 1
            })}
            item
            xs={12}
            md={6}
          >
            <Card className={classes.card} elevation={8}>
              <div className={classes.titleContainer}>
                <Fab
                  className={classes.fab}
                  variant="extended"
                  color="default"
                  onClick={() => setTimeout(() => history.push(route), 250)}
                >
                  <strong>{title}</strong>
                </Fab>
              </div>
              <CardActionArea onClick={() => setTimeout(() => history.push(route), 250)}>
                <CardMedia className={classes.cardImage} image={toUrl(cdnId)} />
              </CardActionArea>
            </Card>
          </Grid>
        ))}
      </Grid>
    </div>
  );
};

export default withRouter(LinkGrid);
